// extracted by mini-css-extract-plugin
export default {"block":"DeleteBlock_block__qJnu5","trash":"DeleteBlock_trash__WGQVY"};